import * as React from 'react';
import styled from 'styled-components';
import stateComponents from '@state/components';
import stateUi from '@state/ui';
import { ElementType } from '@src/interfaces/elements';
import AddInput from './AddComponentInput';
import ComponentItem, { Item } from './ComponentItem';
import { Colors } from '@src/styles';
import PlusSign from '@src/editor/components/PlusSign';
import NewElement from '@src/elements/NewElement';
import { getSelectedElement, getSelectedModifier } from '@src/selector';
import router, { paths, pathToUrl, navigate } from '@state/router';
import logoText from '@src/assets/images/logoText.png';
const LeftMenuBox = styled.div `
  box-shadow: rgba(0, 0, 0, 0.12) 2px 2px 2px;
  background: rgb(248, 248, 248);
  flex: 0 0 200px;
  user-select: none;
  padding-top: 16px;
  z-index: 100;
  overflow: auto;
  max-height: 100vh;
  padding-bottom: 32px;
`;
const Title = styled.div `
  position: relative;
  font-size: 16px;
  letter-spacing: 0.05em;
  font-weight: 500;
  color: ${Colors.grey800};
  padding: 24px 16px 6px 16px;
  user-select: none;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  text-transform: uppercase;
`;
const AddComponentBox = styled.div `
  cursor: pointer;
  width: 12px;
  height: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7%;
  margin-left: 10px;
  vertical-align: middle;
  line-height: 45px;
  color: rgb(152, 161, 164);
  transition: all 200ms ease;

  &:hover {
    color: ${Colors.accent};
  }
`;
const Logo = styled.div `
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 10px;
  padding-right: 21px;
  cursor: pointer;
`;
const LogoImg = styled.img `
  margin-right: -1px;
`;
const A = styled.a `
  text-decoration: none;
`;
const deleteItem = (array, item) => () => {
    const index = array.indexOf(item);
    array.splice(index, 1);
};
const showAddElement = (elementName) => () => {
    stateUi.addingElement = elementName;
};
const addElement = (_) => (value) => {
    stateUi.addingElement = null;
    if (!value) {
        return;
    }
    const newElement = NewElement(value);
    navigate(pathToUrl(paths.element, { componentId: newElement.id }));
    stateComponents.push(newElement);
};
const sortComponents = (component1, component2) => component1.name.localeCompare(component2.name);
const LeftMenu = () => {
    const selectedElement = getSelectedElement();
    const selectedModifierName = getSelectedModifier();
    return (React.createElement(LeftMenuBox, null,
        React.createElement(A, { href: "/" },
            React.createElement(Logo, null,
                React.createElement(LogoImg, { src: logoText, height: 32 }))),
        React.createElement(Title, null,
            "Components",
            React.createElement(AddComponentBox, { onClick: showAddElement(ElementType.Component) },
                React.createElement(PlusSign, null))),
        stateUi.addingElement === ElementType.Component && React.createElement(AddInput, { onSave: addElement(ElementType.Component) }),
        stateComponents
            .filter((element) => element.type === ElementType.Component)
            .concat()
            .sort(sortComponents)
            .map((component) => (React.createElement(ComponentItem, { key: component.id, id: component.id, name: component.name, selected: !selectedModifierName && selectedElement && selectedElement.id === component.id, onDelete: deleteItem(stateComponents, component) }))),
        React.createElement(Title, null,
            "Elements",
            React.createElement(AddComponentBox, { onClick: showAddElement(ElementType.Button) },
                React.createElement(PlusSign, null))),
        stateUi.addingElement === ElementType.Button && React.createElement(AddInput, { onSave: addElement(ElementType.Button) }),
        stateComponents
            .filter((element) => element.type !== ElementType.Component)
            .concat()
            .sort(sortComponents)
            .map((element) => (React.createElement(ComponentItem, { key: element.id, id: element.id, selected: !selectedModifierName && selectedElement && selectedElement.id === element.id, onDelete: deleteItem(stateComponents, element), name: element.name }))),
        React.createElement(Title, null, "Settings"),
        React.createElement(Item, { href: paths.color, selected: router.url === paths.color }, "Styles"),
        React.createElement(Item, { href: paths.font, selected: router.url === paths.font }, "Fonts"),
        React.createElement(Item, { href: paths.assets, selected: router.url === paths.assets }, "Assets"),
        React.createElement(Item, { href: paths.export, selected: router.url === paths.export }, "Exporting")));
};
export default LeftMenu;
